import { render, staticRenderFns } from "./suspectedLoss.vue?vue&type=template&id=446ca700&scoped=true"
import script from "./suspectedLoss.vue?vue&type=script&lang=js"
export * from "./suspectedLoss.vue?vue&type=script&lang=js"
import style0 from "./suspectedLoss.vue?vue&type=style&index=0&id=446ca700&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ca700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446ca700')) {
      api.createRecord('446ca700', component.options)
    } else {
      api.reload('446ca700', component.options)
    }
    module.hot.accept("./suspectedLoss.vue?vue&type=template&id=446ca700&scoped=true", function () {
      api.rerender('446ca700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/cmp/suspectedLoss.vue"
export default component.exports